import UpsellingAddons from './upselling-addons';

export default UpsellingAddons;
